import moment from 'moment'
import React, {FC} from 'react'

type Props = {
  phone: string
}

const UserDateCell: FC<Props> = ({phone}) => {

  const momentDate = moment(new Date(phone)).format('lll')

  return <div className='badge badge-light fw-bolder'>{momentDate}</div>
}

export default UserDateCell
